<template>
  <!--
  甲方代表：partyAId
  乙方：customerId
  售后：afterServiceId
  总部：hqId
 -->
  <!-- 终止设备租赁 -->
  <div class="contract-stop-rent">
    <h1 class="item-title">{{ $t('components_contract_stop_rent.he_tong_xin_xi') }}</h1>
    <div class="item-title-info">
      <el-row>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_rent.he_tong_lei_xing') }}:</span>
          <span class="value">{{ getDicValue('crm_contract_type', detail.contractType) }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_rent.he_tong_bian_hao') }}:</span>
          <span class="value">{{ detail.contractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_rent.sghth') }}:</span>
          <span class="value">{{ detail.customContractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_rent.jfsqdbgs') }}:</span>
          <span class="value">{{ detail.partyAName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_rent.yi_fang') }}:</span>
          <span class="value">{{ detail.customerName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_rent.shou_hou_gong_si') }}:</span>
          <span class="value">{{ detail.afterServiceName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_rent.xiang_mu_ming_cheng') }}:</span>
          <span class="value">{{ detail.locationName }}</span>
        </el-col>
        <el-col :span="16">
          <span class="label">{{ $t('components_contract_stop_rent.shi_yong_di_dian') }}:</span>
          <span class="value">{{ detail.country || '' }}{{ detail.province || '' }}{{ detail.city || '' }}{{ detail.useAddress }}</span>
        </el-col>
      </el-row>
    </div>
    <h1 class="item-title">{{ $t('components_contract_stop_rent.sbbgxx') }}</h1>
    <div class="stop-rent-tip" v-if="lastDevice.length">
      <i class="icon icon-tishi"></i>
      <span>{{ $t('components_contract_stop_rent.ji_shen_hao') }}{{ lastDevice.join('，') }}{{ $t('components_contract_stop_rent.yi_xu_zu') }}，{{ $t('components_contract_stop_rent.qxzxzhtohtzzsbzlhzcz', [lastContract.join(',')]) }}</span>
    </div>
    <div style="margin-bottom: 30px">
      <custom-table
        :expand="model.type === 'watch'"
        :default-expand-all="model.type === 'watch'"
        ref="customTb1"
        v-model="selectDevice"
        type="checkbox"
        tableCode="stopDevice1"
        :data="dataList"
        @filter="filterChange"
        @sort="sortChange"
        :filterArr="model.approve || model.type === 'watch' ? [] : ['stopDeviceDate']"
        :slots="model.approve ? ['totalTerm', 'stopDeviceDate'] : ['totalTerm', 'deviceBackTime', 'stopDeviceDate', 'deviceBackOrgName', 'changeRemark']"
      >
        <!-- 展开内容 -->
        <template slot="expand" slot-scope="scope">
          <div v-if="scope.row.deviceBackTime">
            <el-form label-position="top">
              <el-row>
                <el-col :span="5">
                  <el-form-item :label="$t('components_contract_stop_rent.bqysyscy')">
                    <el-input disabled type="number" :min="0" v-model="scope.row.termUseTime" style="width: 90%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item :label="$t('components_contract_stop_rent.sbzlscy')">
                    <el-input disabled type="number" :min="0" v-model="scope.row.rentUseTime" style="width: 90%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item :label="$t('components_contract_stop_rent.shfwscy')">
                    <el-input disabled type="number" :min="0" v-model="scope.row.scStartTime" style="width: 90%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="end-contract-info">
              <el-row>
                <el-col :span="4">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.bqzbysje') }}</span>
                      <span class="value">{{ scope.row.factory.receivedRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.bqshysje') }}</span>
                      <span class="value">{{ scope.row.service.receivedRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_rent.bqjfdbysje') }}</span>
                      <span class="value">{{ scope.row.agent.receivedRental || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="4">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.bqzbkpje') }}</span>
                      <span class="value">{{ scope.row.factory.invoiceAmount || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.bqshkpje') }}</span>
                      <span class="value">{{ scope.row.service.invoiceAmount || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_rent.bqjfdbkpje') }}</span>
                      <span class="value">{{ scope.row.agent.invoiceAmount || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="4">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.zong_bu_zu_jin') }}/{{ $t('components_contract_stop_rent.yue') }}</span>
                      <span class="value">{{ scope.row.factory.receivableFormula || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.shou_hou_zu_jin') }}/{{ $t('components_contract_stop_rent.yue') }}</span>
                      <span class="value">{{ scope.row.service.receivableFormula || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_rent.yi_fang_zu_jin') }}/{{ $t('components_contract_stop_rent.yue') }}</span>
                      <span class="value">{{ scope.row.agent.receivableFormula || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="4">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.bqzbyszj') }}</span>
                      <span class="value">{{ scope.row.factory.receivableRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.bqshyszj') }}</span>
                      <span class="value">{{ scope.row.service.receivableRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_rent.bqjfyszj') }}</span>
                      <span class="value">{{ scope.row.agent.receivableRental || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="4">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.bqzbytje') }}</span>
                      <el-input
                        class="red-input"
                        v-if="model.approve && scope.row.factory.refundAmount !== undefined && isHq"
                        :disabled="model.showProcess || !scope.row.factory.receivedRental"
                        v-input.intp="factoryReceivedRentalMinMax(scope.row)"
                        v-model="scope.row.factory.refundAmount"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.factory.refundAmount || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.bqshytje') }}</span>
                      <el-input
                        class="red-input"
                        v-if="model.approve && scope.row.service.refundAmount !== undefined && isHq"
                        :disabled="model.showProcess || !scope.row.service.receivedRental"
                        v-input.intp="serviceReceivedRentalMinMax(scope.row)"
                        v-model="scope.row.service.refundAmount"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.service.refundAmount || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_rent.bqjfytje') }}</span>
                      <el-input
                        class="red-input"
                        v-if="scope.row.agent.refundAmount !== undefined"
                        :disabled="model.showProcess || !scope.row.agent.receivedRental"
                        v-input.intp="agentReceivedRentalMinMax(scope.row)"
                        v-model="scope.row.agent.refundAmount"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.agent.refundAmount || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="4">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.zbyswyj') }}</span>
                      <el-input
                        class="red-input"
                        v-if="model.approve && scope.row.factory.receivableBreak !== undefined && isHq"
                        type="number"
                        :min="0"
                        :disabled="model.showProcess"
                        v-model="scope.row.factory.receivableBreak"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.factory.receivableBreak || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_rent.shyswyj') }}</span>
                      <el-input
                        class="red-input"
                        v-if="model.approve && scope.row.service.receivableBreak !== undefined && isHq"
                        type="number"
                        :min="0"
                        :disabled="model.showProcess"
                        v-model="scope.row.service.receivableBreak"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.service.receivableBreak || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_rent.jfdbyswyj') }}</span>
                      <el-input
                        class="red-input"
                        v-if="scope.row.agent.receivableBreak !== undefined"
                        type="number"
                        :disabled="model.showProcess"
                        :min="0"
                        v-model="scope.row.agent.receivableBreak"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.agent.receivableBreak || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div>
          </div>
          <div v-else style="text-align: center">{{ $t('Common.com_no_data') }}</div>
        </template>
        <template slot="totalTerm" slot-scope="scope">
          <div v-if="scope.row.termNum && scope.row.totalTerm">{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
        </template>
        <!-- 机器退回日期 （发起时显示） rentalStartTime / rentalEndTime -->
        <template slot="deviceBackTime" slot-scope="scope">
          <custom-date-picker
            :disabled="model.type === 'watch' || !scope.row.bodyNum || scope.row.isExists || disableReturnDevice.includes(scope.row.bodyNum)"
            style="width: 100%"
            v-model="scope.row.deviceBackTime"
            align="right"
            type="datetime"
            :default-value="
              scope.row.rentalStartTime &&
              scope.row.rentalEndTime &&
              ($moment().isBefore(new Date(`${scope.row.rentalStartTime}Z`).getTime(), 'day') || $moment().isAfter(new Date(`${scope.row.rentalEndTime}Z`).getTime(), 'day'))
                ? new Date(`${scope.row.rentalStartTime}Z`)
                : undefined
            "
            value-format="YYYY-MM-DD HH:mm:ss"
            :default-time="$moment().format('HH:mm:ss')"
            :picker-options="{
              disabledDate(time) {
                return scope.row.rentalStartTime && scope.row.rentalEndTime
                  ? $moment(time).isBefore(new Date(`${scope.row.rentalStartTime}Z`).getTime(), 'day') || $moment(time).isAfter(new Date(`${scope.row.rentalEndTime}Z`).getTime(), 'day')
                  : !($moment(time).subtract(7, 'd').isBefore(new Date().getTime(), 'day') && $moment(time).add(7, 'd').isAfter(new Date().getTime(), 'day'));
              },
            }"
            @change="expandChange(scope.row, 'deviceBackTime')"
          ></custom-date-picker>
        </template>
        <!-- 终止租赁日期 （审批时显示）-->
        <template slot="stopDeviceDate" slot-scope="scope">
          <custom-date-picker
            :disabled="model.showProcess"
            style="width: 100%"
            v-model="scope.row.endRentDate"
            align="right"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            @change="expandChange(scope.row, 'endRentDate')"
            :picker-options="{
              disabledDate(time) {
                return scope.row.currentTermStartTime && scope.row.nextTermEndTime
                  ? $moment(time).isBefore(new Date(`${scope.row.currentTermStartTime}Z`).getTime(), 'day') || $moment(time).isAfter(new Date(`${scope.row.nextTermEndTime}Z`).getTime(), 'day')
                  : !($moment(time).subtract(7, 'd').isBefore(new Date().getTime(), 'day') && $moment(time).add(7, 'd').isAfter(new Date().getTime(), 'day'));
              },
            }"
          ></custom-date-picker>
        </template>
        <!-- 退回地点 -->
        <template slot="deviceBackOrgName" slot-scope="scope">
          <custom-select
            width="100%"
            :disabled="model.type === 'watch' || !scope.row.bodyNum || scope.row.isExists || disableReturnDevice.includes(scope.row.bodyNum)"
            v-model="scope.row.deviceBackOrgId"
            url="PartnerHqSc"
            :params="{ orderDeviceId: scope.row.orderDeviceId }"
            :props="{ label: 'partnerName', value: 'partnerOrgId' }"
            @change="onSelectBackOrg($event, scope.row)"
          ></custom-select>
        </template>
        <!-- 设备退回原因 -->
        <template slot="changeRemark" slot-scope="scope">
          <custom-auto
            :disabled="model.type === 'watch' || scope.row.isExists"
            :placeholder="$t('components_contract_stop_rent.mo_ren_tong_shang')"
            v-model="scope.row.changeRemark"
            width="100%"
            value-key="name"
            code="change_order_device_remark"
          ></custom-auto>
        </template>
      </custom-table>
    </div>
    <el-form :model="form" :inline="true" :rules="rules" ref="form" label-width="86px">
      <el-form-item :label="$t('components_contract_stop_rent.shen_qing_miao_shu')" prop="changeDesc">
        <el-input type="textarea" :rows="4" :disabled="model.type === 'watch'" :placeholder="$t('components_contract_stop_rent.qstxsqsm')" v-model="form.changeDesc" style="width: 626px"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customAuto from '@/components/customAuto';

export default {
  components: { customAuto },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '', // 新增时为orderId, 编辑查看时为changeId
          approve: false, // 是否是审批页
          approveCurrentNo: '', // 当前审批在哪一步
        };
      },
    },
  },
  data() {
    return {
      orgList: [],
      dataList: [],
      selectDevice: [],
      lastDevice: [],
      lastContract: [],
      disableReturnDevice: [],
      detail: {},
      form: {
        changeOrderId: '',
        orderId: '',
        changeDesc: '',
        changeOrderDevices: [],
      },
    };
  },
  computed: {
    rules() {
      return {
        changeDesc: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
      };
    },
    // 是否总部
    isHq() {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.bizType === 'HQ';
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    agentReceivedRentalMinMax(row) {
      return [0, row.agent.receivedRental || 0];
    },
    serviceReceivedRentalMinMax(row) {
      return [0, row.service.receivedRental || 0];
    },
    factoryReceivedRentalMinMax(row) {
      return [0, row.factory.receivedRental || 0];
    },
    // 处理数据
    formatData: function (to, form) {
      to.breakType = form.breakType;
      to.orderSharingId = form.orderSharingId;
      to.rentUseTime = form.rentUseTime;
      to.scStartTime = form.scStartTime;
      to.termUseTime = form.termUseTime;
      // 自定义字段
      const breakFeeList = form.breakFeeList || [];
      const factory = breakFeeList.find((t) => t.receivableOrgType === 'HQ') || {}; // 总部
      const service = breakFeeList.find((t) => t.receivableOrgType === 'SC') || {}; // 售后公司
      let agent = breakFeeList.find((t) => t.receivableOrgType === 'JV' || t.receivableOrgType === 'JV_SC') || {}; // 甲方代理

      // 甲方代表和总部一致， 保留甲方代表（数据取总部的）
      if (this.detail.partyAId === this.detail.hqId) {
        agent = factory;
      }

      factory.receivableBreak = factory.receivableBreak === undefined ? '' : factory.receivableBreak;
      service.receivableBreak = service.receivableBreak === undefined ? '' : service.receivableBreak;
      agent.receivableBreak = agent.receivableBreak === undefined ? '' : agent.receivableBreak;
      agent.refundAmount = agent.refundAmount === undefined ? '' : agent.refundAmount;

      to.breakFeeList = form.breakFeeList || [];
      to.agentBreakFee = form.agentBreakFee === undefined ? '' : form.agentBreakFee;
      to.factory = factory;
      to.service = service;
      to.agent = agent;
    },
    // 修改终止时间重新获取违约账单
    expandChange: function (row, datekey) {

      if (datekey === 'deviceBackTime') {
        const before = this.$moment(row.deviceBackTime).isBefore(new Date(`${row.rentalStartTime}Z`).getTime());
        if (before) {
          row.deviceBackTime = row.rentalStartTime;
        }
      }

      if (row[datekey]) {
        this.$getJSON(apis.OrderChangeDevice, {
          orderDeviceId: row.orderDeviceId,
          endRentDate: row[datekey],
        }).then((res) => {
          row.breakType = res.data.breakType;
          row.orderSharingId = res.data.orderSharingId;
          this.formatData(row, {});
          this.$nextTick(() => {
            this.formatData(row, res.data || {});
            if (this.model.approve) {
              row.breakFeeList.forEach((item) => {
                const obj = row.cacheBreakFeeList.find((t) => t.payableOrgId === item.payableOrgId && t.receivableOrgId === item.receivableOrgId) || {};
                item.changeDeviceBreakId = obj.changeDeviceBreakId;
              });
            }
          });
        });
      } else {
        this.formatData(row, {});
      }
    },
    // 组织下拉
    getList: function (list) {
      this.orgList = list;
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.orderId = this.model.changeId;
        this.getOrderInfo(() => {
          this.getDeviceList();
        });
      }
      if (this.model.type === 'edit') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.getDeviceList(list);
        });
      }
      if (this.model.type === 'watch') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.dataList = list;
          this.dataList.forEach((item) => {
            item.isExists = true;
            item.endRentDate = item.endRentDate || '';
            if (this.model.approve) {
              if (!this.model.showProcess) {
                item.endRentDate = item.currentTermEndTime || '';
                item.endRentDateSource = item.currentTermEndTime || ''; // 记录原数据，提交需减1秒
                this.expandChange(item, 'endRentDate');
              }
            }
            item.cacheBreakFeeList = item.breakFeeList || []; // 存取 changeDeviceBreakId 用
            this.formatData(item, item);
            this.$refs.customTb1.$emit('toggleRowSelection', item, true);
          });
        });
      }
    },
    // 订单信息
    getOrderInfo: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.ChangeOrderInfo, {
        orderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
        cb();
      });
    },
    // 获取变更详情
    getChangeDetail: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.OrderChangeInfo, {
        changeOrderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
        this.form.orderId = res.data.orderId;
        this.form.changeDesc = res.data.changeDesc;
        cb(res.data.changeDeviceInfos);
      });
    },
    // 合同设备列表
    getDeviceList: function (selectDevice) {
      this.$getJSON(apis.OrderChangeDeviceList, {
        orderId: this.form.orderId,
        showDeviceType: 0,
        showCurrentPeriod: `${this.detail.orderClass}` === '10' ? undefined : 1,
        bizState: ['10', '21', '22', '29'],
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.deviceBackTime = ''; // 默认有值，需要确认是否置空
          item.deviceBackOrgId = '';
          item.deviceBackOrgName = '';
          this.formatData(item, {});
        });
        this.dataList = list;
        // 编辑状态时
        if (selectDevice) {
          this.dataList.forEach((item) => {
            const row = selectDevice.find((t) => t.orderDeviceId === item.orderDeviceId);
            if (row) {
              item.deviceBackTime = row.deviceBackTime;
              item.deviceBackOrgId = row.deviceBackOrgId;
              item.deviceBackOrgName = row.deviceBackOrgName;
              item.changeRemark = row.changeRemark;
              this.formatData(item, row);
              this.$refs.customTb1.$emit('toggleRowSelection', item, true);
            }
          });
        }
        // 在原合同时（续租设备处理）
        const lastDeviceList = list.filter((t) => !!t.renewalOrderDeviceId);
        if (lastDeviceList.length > 0) {
          this.lastDevice = lastDeviceList.map((f) => f.bodyNum);
          this.lastContract = [...new Set(lastDeviceList.map((f) => f.renewalContractNo))];
          this.dataList.forEach((item) => {
            item.isExists = !!item.renewalOrderDeviceId;
          });
        }
        // 在续租合同时（续租设备处理）
        const renewalDeviceList = list.filter((t) => !!t.lastOrderDeviceId);
        if (renewalDeviceList.length > 0) {
          // 未到期(原合同)
          const list1 = renewalDeviceList.filter((t) => t.lastBizState < 43);
          this.disableReturnDevice = list1.map((t) => t.bodyNum);
          // 已到期(原合同),不用处理
          // const list2 = renewalDeviceList.filter(t => t.lastBizState >= 43);
        }
      });
    },
    // 选择退回地址
    onSelectBackOrg: function (data, row) {
      row.deviceBackOrgName = data.partnerName;
    },

    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.selectDevice.length) {
          this.$message.error(this.$t('components_contract_stop_rent.qing_xuan_ze_she_bei'));
          return;
        }
        const hasEmpty = this.selectDevice.filter((f) => !this.disableReturnDevice.includes(f.bodyNum)).find((t) => t.bodyNum && (!t.deviceBackOrgId || !t.deviceBackTime));
        if (hasEmpty) {
          this.$message.error(this.$t('components_contract_stop_rent.qxzjqthrqhsbthdz'));
          return;
        }
        const hasFirstEmpty = !this.selectDevice[0]['changeRemark'];
        if (hasFirstEmpty) {
          this.$message.error(this.$t('components_contract_stop_rent.qtxsbthyy'));
          return;
        }
        this.form.isStartApprove = approve || 0;
        this.form.changeOrderDevices = this.$formatCopyUp(this.selectDevice, ['changeRemark']);
        this.$postJSON(apis.StopDeviceRent, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
        });
      });
    },
  },
};
</script>

<style lang="scss">
.contract-stop-rent {
  .red-input input {
    color: red;
    font-weight: bold;
  }
  .stop-rent-tip {
    background: rgba(254, 244, 219, 1);
    margin-bottom: 16px;
    padding-left: 10px;
    .icon {
      color: #eebf4d;
      font-size: 12px;
      margin-right: 10px;
    }
    span {
      line-height: 32px;
      color: #6c757d;
      font-size: 12px;
    }
  }
}
</style>
